import { ActionText, AutoTooltip, Column, Icon, Row, Text, TooltipContent } from "@mdotm/shadcn/legacy/components";
import { ForEach } from "@mdotm/utils/react-extra";
import { typedObjectEntries } from "@mdotm/shadcn/legacy/utils";
import type { ReasonToMessageMap } from "./types";

export function BulkActionNotSuitableSummary<Reason extends string, T extends { name?: string } = { name?: string }>({
	unavailable,
	reasonToMessage,
	redirectUrl,
	hideRedirectUrl,
	showEntityNames,
}: {
	unavailable: Record<Reason, T[]>;
	reasonToMessage: ReasonToMessageMap<Reason>;
	redirectUrl: string;
	hideRedirectUrl?: boolean;
	showEntityNames?: boolean;
}): React.JSX.Element {
	return (
		<Column flexGrow={0} gap={8}>
			<ul className="list-disc pl-4">
				<ForEach collection={typedObjectEntries(unavailable).filter(([_reason, items]) => items.length > 0)}>
					{([reason, items]) => (
						<li>
							<Row gap={4} alignItems="center">
								<Text type="Body/M/Book">
									{reasonToMessage[reason](items.length)}{" "}
									{showEntityNames && (
										<AutoTooltip
											trigger={({ innerRef }) => (
												<Text type="Body/M/Link" className="underline" innerRef={innerRef}>
													view the full list
												</Text>
											)}
											position="top"
											hideArrow
										>
											<TooltipContent hideCloseButton>
												<ul className="list-disc pl-3">
													<ForEach collection={items}>
														{(item) => (
															<li>
																<Text type="Body/S/Book">{item.name ?? "-"}</Text>
															</li>
														)}
													</ForEach>
												</ul>
											</TooltipContent>
										</AutoTooltip>
									)}
								</Text>
							</Row>
						</li>
					)}
				</ForEach>
			</ul>
			{!hideRedirectUrl && (
				<Row gap={4} alignItems="center" flexGrow={0}>
					<ActionText href={redirectUrl} target="_blank" rel="opener">
						Open this selection in a new tab
					</ActionText>
					<Icon icon="Expand" />
				</Row>
			)}
		</Column>
	);
}
